<template>
  <v-card class="elevation-0 subscriptionForm">
    <v-card-title>Créer votre compte</v-card-title>
    <v-card-text>
      <v-form v-model="formValid" ref="subscribe">
        <v-container>
          <v-row>
            <p>
              Vous avez déjà un compte,
              <a href="#" @click="$emit('connection')">connectez-vous ici!</a>
            </p>
          </v-row>
          <v-row>
            <v-radio-group v-model="model.account_type" row>
              <v-radio value="entreprise" label="Entreprise" />
              <v-radio value="independant" label="Indépendant" />
            </v-radio-group>
          </v-row>
          <v-row>
            <v-select
              :items="[{value:'mr',text:'Monsieur'},{value:'mme', text:'Madame'}]"
              placeholder="Titre"
              hide-details="auto"
              v-model="model.title"
              :rules="[mandatoryRules]"
              class="title"
            ></v-select>
          </v-row>
          <v-row>
            <v-text-field
              placeholder="Nom"
              hide-details="auto"
              v-model="model.lastname"
              :rules="[mandatoryRules]"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              placeholder="Prénom"
              hide-details="auto"
              v-model="model.firstname"
              :rules="[mandatoryRules]"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              :placeholder="(model.title=='entreprise')?'Nom de l\'agence':'Nom du compte'"
              hide-details="auto"
              v-model="model.account_name"
              :rules="[mandatoryRules]"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              placeholder="Votre adresse"
              hide-details="auto"
              v-model="model.account_address"
              :rules="[mandatoryRules]"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              placeholder="Email"
              hide-details="auto"
              v-model="model.email"
              :rules="[emailRules, mandatoryRules]"
              :validate-on-blur="true"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              placeholder="Téléphone"
              hide-details="auto"
              v-model="model.phone"
              :rules="[mandatoryRules]"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              placeholder="Mot de passe"
              hide-details="auto"
              type="password"
              v-model="model.password"
              :rules="[mandatoryRules]"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              placeholder="Repetez le mot de passe"
              hide-details="auto"
              type="password"
              v-model="model.repeatPassword"
              :rules="[mandatoryRules]"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-checkbox
              label="J'accepte les conditions générales d'utilisation, de vente et la Politique de confidentialité de Marketpro."
              v-model="model.conditions"
              :rules="[mandatoryRules]"
            ></v-checkbox>
          </v-row>
          <v-row>
            <v-btn color="primary" small @click="create()" class="themed">Valider</v-btn>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data: function() {
    return {
      model: {
        account_type: "entreprise",
        title: null,
        lastname: null,
        firstname: null,
        email: null,
        phone: null,
        password: null,
        repeatPassword: null,
        account_name: null,
        account_address: null,
        conditions: null
      },
      formValid: false,
      mandatoryRules: v => !!v || "Ce champ est obligatoire",
      emailRules: v =>
        /.+@.+\..+/.test(v) || "L'adresse e-mail n'est pas valable"
    };
  },
  methods: {
    ...mapActions("auth", ["createAccount"]),
    create() {
      if (this.$refs.subscribe.validate()) {
        this.createAccount(this.model).then(() => {
          this.$router.push({ name: "Home" });
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.subscriptionForm {
  /deep/ .v-select__slot {
    padding: 0.2rem 0.5rem;
    border: 1px solid #cacaca;
    border-radius: 20px;
    font-size: 18px;
    font-weight: normal;
    color: #cacaca;
  }
}
</style>